<template>
	<div id="mapStyle" class="mapboxgl-ctrl mapboxgl-ctrl-group">
		<button v-on:click="toggleStyle" class="mapboxgl-ctrl-icon">
			<div v-if="!satellite">
				<img src="../../assets/img/satelliteThumb.png"/>
			</div>
			<img v-if="satellite" src="../../assets/img/mapThumb.png"/>
		</button>
	</div>
</template>
<script>
export default {
	name:'map-style',
	computed: {
		satellite:function(){
			return (this.$store.state.map.params.style === 'satellite')? true: false;
		}
	},
	methods:{
		toggleStyle: function(){			
        	if (this.$store.state.map.params.style == 'satellite') {
        		this.$store.dispatch('MAP_PARAMS_SET', {style: 'vector'});
        		return;
			}
        	this.$store.dispatch('MAP_PARAMS_SET', {style: 'satellite'});
		}
	}
}
</script>
<style>
#mapStyle img{
	width:100%;
}
#mapStyle .mapboxgl-ctrl-icon{
	border: 2px solid #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/map/map-style.vue